<template>
    <div class="time">
      <p>{{ trimmedTime }}</p>
      <span class="time-small"></span>
      <span class="time-small">{{ trimmedTime + ":30"}}</span>
      <span class="time-small"></span>
    </div>
</template>
<script>
export default {
  props: ["time"],
  data() {
    return {
      trimmedTime: ""
    };
  },
  methods: {
    trimTime() {
      var t = this.time.trim(":");
      this.trimmedTime = t[0] + t[1];
    }
  },
  created() {
    this.trimTime();
  }
};
</script>
<style scoped>
.time {
  height: 100px;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  opacity: 0.54;
  color: #657786;
}
.time p {
  display: block;
  margin: 0;
  height: 25%;
  position: relative;
  top: -9px;
  font-weight: 500;
}
.time-small{
  height: 25%;
  font-size: 9px;
  font-weight: 300;
  padding-top: 1px;
  display: block;
}
</style>
